import { CardObject } from '@phaser/objects/Card.object';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class HackingIndicatorBehavior {
  private _scene = Game.current;

  constructor(private _card: CardObject) {}

  public show() {
    const img = this._scene.add.image(0, 0, 'sprites', 'hacking')
      .setScale(0.2)
      .setDepth(DEPTH.CARD);
    this._card.container.add(img);
  }
}